import { useTitle } from '@vueuse/core';

export interface BrowserTitleComposable {
  setTitle(title?: string): void;
}

export default function useBrowserTitle(): BrowserTitleComposable {
  const browserTitle = useTitle();

  function setTitle(title = ''): void {
    browserTitle.value = title;
  }

  return {
    setTitle,
  };
}
